import { render, staticRenderFns } from "./Onstar.vue?vue&type=template&id=3d6ef239&scoped=true&"
import script from "./Onstar.vue?vue&type=script&lang=js&"
export * from "./Onstar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ef239",
  null
  
)

export default component.exports